import { Divider, Row, Space, Typography } from 'antd';
import Image from 'next/image';
import grispiGif from '../../public/grispi.gif';
import { getCurrentYear } from '../utils/helpers';

const { Text, Title, Paragraph } = Typography;

function Content() {
    return (
        <>
            <Title level={3}>GİZLİLİK POLİTİKAMIZ VE AYDINLATMA METNİ</Title>

            <Paragraph>
                GRİSPİ BİLİŞİM TEKNOLOJİLERİ A.Ş. olarak, kullanıcılarımızın kişisel verilerinin korunması
                önceliğimizdir. Bu kapsamda, 6698 s. Kişisel Verilerin Korunması Kanunu (KVKK) kapsamında, veri
                sorumlusu sıfatı ile sizleri aydınlatmak isteriz.
            </Paragraph>
            <Paragraph>
                Kayıt altına aldığımız kişisel verileriniz, KVKK’ya uygun olarak, işbu metinde yer alan işlenme ve
                aktarılma amacına, toplanma yöntemine, hukuki sebebine, toplanma faaliyetine uygun şekilde, hizmet
                amaçlarımız, yasal yükümlülüklerimiz ile bağlantılı şekilde işlenebilecek, yurt içi ve yurt dışında
                bulunan üçüncü kişilere aktarılabilecek, saklanabilecek, profilleme için kullanılabilecek ve
                sınıflandırılabilecektir. Yine işbu aydınlatma metni ile KVKK kapsamındaki haklarınız hususunda
                bilgilendirilmeniz amaçlanmaktadır.
            </Paragraph>
            <Paragraph>
                GRİSPİ BİLİŞİM TEKNOLOJİLERİ A.Ş. hizmetlerinin kullanılabilmesi için bir kısım kişisel bilgileriniz
                (ad-soyad, telefon, e-posta, doğum tarihi, medeni durum vb.) sizlerden talep edilebilir. İlgili kişisel
                verileriniz ile toplanan veriler GRİSPİ BİLİŞİM TEKNOLOJİLERİ A.Ş. bünyesinde muhafaza edilecektir.
                GRİSPİ BİLİŞİM TEKNOLOJİLERİ A.Ş. üye firmaları bu bilgilere ulaşabilir ve işletme amacına uygun olarak
                tarafınıza e-posta, telefon, SMS üzerinden ulaşabilir.
            </Paragraph>
            <Divider />
            <Title level={5}>1- KİŞİSEL VERİLERİ İŞLEME AMAÇLARIMIZ</Title>
            <Paragraph>
                GRİSPİ BİLİŞİM TEKNOLOJİLERİ A.Ş. tarafından toplanan kişisel verileriniz aşağıdaki amaçlar
                doğrultusunda Kanun’un 5’inci ve 6’ıncı maddelerinde belirtilen kişisel veri işleme şartları ve amaçları
                dâhilinde ve özellikle 5’inci maddenin 1. Fıkrası uyarınca “Açık rıza” ile, 2’inci fıkrasının a bendi
                uyarınca “Kanunlarda açıkça öngörülmesi” , b bendi uyarınca “Fiili imkânsızlık nedeniyle rızasını
                açıklayamayacak durumda bulunan veya rızasına hukuki geçerlilik tanınmayan kişinin kendisinin ya da bir
                başkasının hayatı veya beden bütünlüğünün korunması için zorunlu olması”, c bendi uyarınca “Bir
                sözleşmenin kurulması veya ifasıyla doğrudan doğruya ilgili olması kaydıyla, sözleşmenin taraflarına ait
                kişisel verilerin işlenmesinin gerekli olması”, ç bendi uyarınca “Veri sorumlusunun hukuki yükümlülüğünü
                yerine getirebilmesi için zorunlu olması”, d fıkrası uyarınca “İlgili kişinin kendisi tarafından
                alenileştirilmiş olması”, e bendi uyarınca “Bir hakkın tesisi, kullanılması veya korunması için veri
                işlemenin zorunlu olması”, f bendi uyarınca “İlgili kişinin temel hak ve özgürlüklerine zarar vermemek
                kaydıyla, veri sorumlusunun meşru menfaatleri için veri işlenmesinin zorunlu olması” ve 6. Maddesinin 2.
                Fıkrasında belirtilen “Açık rıza” ve 3. Fıkrasında belirtilen “Özel nitelikli kişisel verilerin, sağlık
                ve cinsel hayat dışında kalanlarının kanunlarda ön görülen hallerde açık rıza alınmadan işlenebilmesi”,
                hukuki sebeplerine dayanılarak işlenebilecektir.
            </Paragraph>
            <Paragraph>
                GRİSPİ BİLİŞİM TEKNOLOJİLERİ A.Ş. olarak sunduğumuz ürün ve hizmetlerin ilgililerin beğenisi, kullanım
                alışkanlıkları ve ihtiyaçlarına göre özelleştirilerek ilgili kişilere önerilmesi ve tanıtılması için
                gerekli olan aktivitelerin planlanması ve yürütülmesi için; Üye/kullanıcı memnuniyeti aktivitelerinin
                planlanması ve/veya yürütülmesi için, Ürün ve hizmetlerin satış ve pazarlaması için pazar araştırması
                faaliyetlerinin planlanması ve/veya yürütülmesi için, Ürün ve/veya hizmetlerin pazarlama süreçlerinin
                planlanması ve/veya yürütülmesi için, GRİSPİ BİLİŞİM TEKNOLOJİLERİ A.Ş. sunduğu ürün veya hizmetlerden
                en yüksek faydanın elde edilmesi için ilgili süreçlerin planlanması ve/veya yürütülmesi için;
            </Paragraph>
            <Paragraph>
                GRİSPİ BİLİŞİM TEKNOLOJİLERİ A.Ş. tarafından sunulan ürün ve hizmetlerden ilgili kişileri faydalandırmak
                için gerekli çalışmaların iş birimlerimiz tarafından yapılması ve ilgili iş süreçlerinin yürütülmesi
                kapsamında, ürün ve/veya hizmetlerin satış süreçlerinin planlanması ve/veya yürütülmesi, satış sonrası
                destek hizmetleri aktivitelerinin planlanması ve/veya yürütülmesi, üye/kullanıcı ilişkileri yönetimi
                süreçlerinin planlanması ve/veya yürütülmesi, üye/kullanıcı talep ve/veya şikâyetlerinin takibi ve
                sonuçlandırılması, sözleşme süreçlerinin ve/veya hukuki taleplerin takibi;
            </Paragraph>
            <Paragraph>
                GRİSPİ BİLİŞİM TEKNOLOJİLERİ A.Ş. ve onunla iş ilişkisi içerisinde olan ilgili kişilerin hukuki, teknik
                ve ticari iş güvenliğinin sağlanması amacıyla; GRİSPİ BİLİŞİM TEKNOLOJİLERİ A.Ş. ve denetim
                faaliyetlerinin planlanması ve/veya yürütülmesi, GRİSPİ BİLİŞİM TEKNOLOJİLERİ A.Ş. faaliyetlerinin işin
                gereklerine ve/veya ilgili mevzuata uygun olarak yürütülmesinin sağlanması için gerekli operasyonel
                faaliyetlerin planlanması ve yerine getirilmesi, GRİSPİ BİLİŞİM TEKNOLOJİLERİ A.Ş. ve operasyonlarının
                güvenliğinin sağlanması, verilerin doğru ve güncel olmasının sağlanması, Yetkili kuruluşlara mevzuattan
                kaynaklı bilgi verilmesi GRİSPİ BİLİŞİM TEKNOLOJİLERİ A.Ş. ve tarafından yürütülen ticari faaliyetlerin
                gerçekleştirilmesi için ilgili iş birimlerimiz tarafından gerekli çalışmaların yapılması ve buna bağlı
                iş süreçlerinin yürütülmesi;
            </Paragraph>
            <Paragraph>
                Bilgi güvenliği süreçlerinin planlanması, denetimi ve yürütülmesi, bilgi teknolojileri alt yapısının
                oluşturulması, yönetilmesi ve kontrolü, finans ve/veya muhasebe işlerinin takibi, sigorta işlerinin
                takibi, hukuk işlerinin takibi, vergi işlerinin takibi, iş faaliyetlerinin etkinlik/verimlilik ve/veya
                yerindelik analizlerinin gerçekleştirilmesi faaliyetlerinin planlanması ve/veya yerine getirilmesi, iş
                faaliyetlerinin planlanması ve yerine getirilmesi, kurumsal iletişim faaliyetlerinin planlanması ve
                yerine getirilmesi, lojistik ve depolama faaliyetlerinin planlanması ve yerine getirilmesi, üretim,
                tedarik ve/veya operasyon süreçlerinin planlanması ve yerine getirilmesi;
            </Paragraph>
            <Paragraph>
                GRİSPİ BİLİŞİM TEKNOLOJİLERİ A.Ş. ticari ve/veya iş stratejilerinin planlanması ve icrası kapsamında,
                hizmet sunma, aktivite gerçekleştirme, kampanya yapma ve reklam verme faaliyetleri ile iş ortakları,
                çalışanlar ve/veya sunulan hizmetlerin performans değerlendirme faaliyetleri kapsamında işlenmektedir.
            </Paragraph>
            <Paragraph>
                {`Bununla birlikte, kişisel bilgileriniz, aramızda kurulan hukuki ilişkiden kaynaklanan
                            yükümlülüklerin ifası, pazarlama, reklam, dönemsel kampanya çalışmaları, müşteri
                            profillerine yönelik özel promosyon faaliyetlerinin kurgulanması ve istenmeyen e-postaların
                            iletilmemesine yönelik müşteri "sınıflandırma" çalışmalarında, müşteri profil ve davranış
                            sınıflandırmalarında, müşteri memnuniyet şikayetlerinin değerlendirilmesi ve analiz
                            faaliyetleri, hedefleme, strateji ve verimlilik çalışmalarının yapılması, sosyal medya,
                            arama motorları vb. farklı kanallarda pazarlama faaliyetlerinin yürütülmesi, müşterilere
                            genel ve özel nitelikte teklifler, ürünler ve hizmetler sunulması ve bu kapsamda çağrı
                            merkezinin hizmetlerinden faydalanılması, müşteri ile yapılan telefon görüşmelerinin
                            kalitesinin ölçülmesi ve değerlendirilmesi ile yasal ve sözleşmeden doğan
                            yükümlülüklerimizin ifası amacı ve işbu metinde açıklanan amaçlar doğrultusunda
                            işlenecektir.`}
            </Paragraph>
            <Divider />
            <Title level={5}>2- KİŞİSEL VERİLERİN AKTARILABİLİNECEĞİ KİŞİLER İLE AKTARIM AMACI</Title>
            <Paragraph>
                GRİSPİ BİLİŞİM TEKNOLOJİLERİ A.Ş. müşterilerine daha kolay ulaşmak, reklam, tanıtım ve promosyon
                faaliyetlerinin yürütülmesi amaçları ile, GRİSPİ BİLİŞİM TEKNOLOJİLERİ A.Ş. iş ortakları olan e-posta
                iletim firmaları; GRİSPİ BİLİŞİM TEKNOLOJİLERİ A.Ş. müşteri panelleri, Sosyal medya şirketleri,
                (Örneğin, facebook.com, twitter.com, youtube.com, instagram.com ve benzerleri); İnternet arama motoru
                şirketleri (örneğin google.com, yandex.com ve benzerleri) SMS gönderim şirketleri ile yurt içinde ve
                yurt dışında bulunan depolama, arşivleme, bilişim teknolojileri desteği (sunucu, hosting, program, bulut
                bilişim), bilişim güvenliği gibi alanlarda destek aldığımız üçüncü kişilerle, GRİSPİ BİLİŞİM
                TEKNOLOJİLERİ A.Ş. adına veri işleyen, müşteri memnuniyeti ölçümleme, profilleme desteği veren, satış ve
                pazarlama alanında kişisel verilerin işlenmesi gereken konularda destek veren firmalarla, denetim
                şirketleri ile paylaşılabilmektedir.
            </Paragraph>
            <Paragraph>
                GRİSPİ BİLİŞİM TEKNOLOJİLERİ A.Ş. tarafından toplanan kişisel verilerin yukarıda detayları verilen
                ticari faaliyetlerin gerçekleştirilmesi için ilgili iş birimlerimiz tarafından gerekli çalışmaların
                yapılması ve buna bağlı iş süreçlerinin yürütülmesi, iş ilişkisi içerisinde olan ilgili kişilerin
                hukuki, teknik ve ticari iş güvenliğinin ve haklarının temin edilmesi amaçlarıyla iştiraklerimize,
                hissedarlarımıza, iş ortaklarımıza, kanunen yetkili kamu kurumları ve özel kişiler ile diğer kişilerle
                KVKK’nın 8. ve 9. maddelerinde belirtilen kişisel veri işleme şartları ve amaçları çerçevesinde
                paylaşılabilecektir.
            </Paragraph>
            <Paragraph>
                GRİSPİ BİLİŞİM TEKNOLOJİLERİ A.Ş. topladığı bilgileri, yasal zorunluluklar ve yükümlülükler haricinde,
                söz konusu üyenin haberi ya da aksi bir talimatı olmaksızın hiçbir nedenle ticari amaçla kullanmamakta
                ve de satmamaktadır.
            </Paragraph>
            <Paragraph>
                Bilgileriniz, ancak resmi makamlarca usulü dairesinde bu bilgilerin talep edilmesi halinde ve
                yürürlükteki emredici mevzuat hükümleri gereğince resmi makamlara açıklama yapmak zorunda olduğu
                durumlarda resmi makamlara sizin bilginiz haricinde açıklanabilecektir.
            </Paragraph>
            <Divider />
            <Title style={{ alignSelf: 'start' }} level={5}>
                3- KİŞİSEL VERİLERİ TOPLAMA YÖNTEMİ
            </Title>
            <Paragraph>
                Kişisel verileriniz yukarıda belirttiğimiz üzere GRİSPİ BİLİŞİM TEKNOLOJİLERİ A.Ş. hizmetinden
                yararlanmanız için gereken girişlerin yapılması ve formların doldurulması sırasında işlenmektedir.
            </Paragraph>
            <Divider />
            <Title level={5}>4- KİŞİSEL VERİLERİ SAKLAMA SÜRESİ</Title>
            <Paragraph>
                GRİSPİ BİLİŞİM TEKNOLOJİLERİ A.Ş. elde ettiği kişisel verileri, yasal mevzuattan kaynaklanan
                yükümlülükleri yerine getirebilmesi, üyelerine/kullanıcılarına sunduğu hizmetin optimizasyonu ile işbu
                KVKK Aydınlatma Metninde ve GRİSPİ BİLİŞİM TEKNOLOJİLERİ A.Ş. ÜYELİK SÖZLEŞMESİ’nde işlendikleri amaç
                için gerekli olan süre kadar muhafaza edecektir. 6698 sayılı Kanun md. 7 fıkra 1.’e göre işbu metin
                kapsamındaki kişisel veriler, işlenmesi gerektiren amaç ortadan kalktığında ve/veya mevzuat uyarınca
                verilerin işlenmesi için zorunlu olan zamanaşımı süreleri dolduğunda ilgili mevzuat kapsamında
                silinecek, yok edilecek veya anonimleştirilecektir.
            </Paragraph>
            <Divider />
            <Title level={5}>5- KİŞİSEL VERİ SAHİPLERİNİN HAKLARI</Title>
            <Paragraph>
                KVKK ve ilgili mevzuat uyarınca ilgililer, GRİSPİ BİLİŞİM TEKNOLOJİLERİ A.Ş.’ye başvurarak kendileriyle
                ilgili;
                <ul>
                    <li>Kişisel verilerin işlenip işlenmediğini öğrenme,</li>
                    <li>Kişisel verileri işlenmişse buna ilişkin bilgi talep etme,</li>
                    <li>
                        Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,
                    </li>
                    <li>Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme,</li>
                    <li>
                        Kişisel verilerin eksik veya yanlış işlenmiş olması halinde bunların düzeltilmesini isteme ve bu
                        kapsamda yapılan işlemin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,
                    </li>
                    <li>
                        İlgili mevzuatta öngörülen şartlar çerçevesinde kişisel verilerin silinmesini veya yok
                        edilmesini isteme,
                    </li>
                    <li>
                        İlgili mevzuat uyarınca yapılan düzeltme, silme ve yok edilme işlemlerinin, kişisel verilerin
                        aktarıldığı üçüncü kişilere bildirilmesini isteme,
                    </li>
                    <li>
                        İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişinin
                        kendisi aleyhine bir sonucun ortaya çıkmasına itiraz etme,
                    </li>
                </ul>
                Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması halinde zararın giderilmesini
                talep etme, haklarına sahiptir. İlgili hakların kullanılması için usul ve yöntemler Kişisel Verileri
                Koruma Kurumu tarafından yayınlanan tebliğde belirlenen şart ve yöntemlere göre yapılmalıdır.
            </Paragraph>
            <Paragraph>
                GRİSPİ BİLİŞİM TEKNOLOJİLERİ A.Ş., yukarıda yer alan talepler uyarınca, gerekçeli olumlu/olumsuz
                yanıtını, en kısa sürede ve en geç 30 gün içerisinde yazılı veya dijital ortamdan gerçekleştirebilir.
                Talebe konu işlemlerin bir maliyet gerektirmesi halinde, Kişisel Verilerin Korunması Kurulu tarafından,
                6698 Sayılı Kişisel Verilerin Korunması Kanunu’nun 13. Maddesine göre belirlenen tarife üzerinden ücret
                ve masraf talep edilmesi mümkündür.
            </Paragraph>
            <Divider />
            <Title level={5}>KİŞİSEL VERİLERİN KORUNMASI KANUNU AÇIK RIZA METNİ</Title>
            <Paragraph>
                {`GRİSPİ BİLİŞİM TEKNOLOJİLERİ A.Ş. tarafından sağlanan hizmetten faydalanmak için giriş
                            yaparken/kayıt olurken veya hizmetlerimizden faydalanırken açık rızanızı verdiğiniz hallerde
                            yukarıda yer alan "Gizlilik Politikası ve Aydınlatma Metni"ni okuduğunuzu, anladığınızı ve
                            kişisel verilerinizin KVKK kapsamında GRİSPİ BİLİŞİM TEKNOLOJİLERİ A.Ş. tarafından yukarıda
                            belirtilen yöntemler ile toplanmasına, yukarıda belirtilen amaçlar dahilinde işlenmesine ve
                            yine yukarıda belirtilen yurt içindeki ve yurt dışındaki üçüncü (gerçek/tüzel) kişilere
                            aktarılmasına açık rıza verdiğinizi kabul ve beyan etmiş olmaktasınız.`}
            </Paragraph>
            <Divider />
            <Space direction="vertical" className="full-width">
                <Text strong>Talepleriniz İçin</Text>
                <Text>
                    <strong>Veri Sorumlusu:</strong> GRİSPİ BİLİŞİM TEKNOLOJİLERİ A.Ş.
                </Text>
                <Text>
                    <strong>Adresi:</strong> Kazımdirik mah. 375 sk. No:18 İç Kapı No: 14 Piramit İş Merkezi Bornova -
                    İzmir
                </Text>
                <Text>
                    <strong>E-posta:</strong> kvkk@grispi.com
                </Text>
                <Text>
                    <strong>Tel:</strong> 0232 215 01 06
                </Text>
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1562.305143081896!2d27.189889373016374!3d38.45046975756868!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x1aa72afdf7f21512!2zUGlyYW1pdCDEsMWfIE1lci4!5e0!3m2!1str!2str!4v1645109494227!5m2!1str!2str"
                    width="100%"
                    height="250"
                    style={{ border: 0 }}
                    loading="lazy"
                />
            </Space>
        </>
    );
}
export default function PrivacyPolicyContent({ isOnModal = true }: { isOnModal?: boolean }) {
    return (
        <Space direction="vertical" size="middle" className="full-width" align="center">
            <Image src={grispiGif} alt="Picture of the GRISPI" width={175} height={75} layout="fixed" />
            {isOnModal ? (
                <Row
                    style={{
                        height: '58vh',
                        padding: '24px',
                        overflow: 'hidden',
                        overflowY: 'scroll'
                    }}
                >
                    <Content />
                </Row>
            ) : (
                <Content />
            )}

            {isOnModal ? <Space>© Grispi, {getCurrentYear()}</Space> : null}
        </Space>
    );
}
